import React from 'react'
import { Updater, async, fromJSX, Widget } from 'widgets-for-react'
import { InviewProps, SVGIconProps } from '../blocksState'
import { AllCasesBlockLayout } from './allCasesBlockLayout'
import { AllCasesBlockState, AllCases } from './allCasesBlockState'

export type AllCasesBlock = {
  index: number
  inview?: InviewProps
  title?: React.ReactNode
  casesState: AllCasesBlockState
  SVGIcon?: SVGIconProps
}

export const allCasesBlockWidget = (
  block: AllCasesBlock
): Widget<Updater<AllCasesBlockState>> =>
  async<AllCases>(block.casesState, courses =>
    fromJSX(() => <AllCasesBlockLayout {...block} children={courses} />)
  )
